define('views/content/customers',['require','views/base/list_page_view','views/components/customer/customers','collections/customers','text!templates/content/customers.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var CustomersView = require('views/components/customer/customers');
    var CustomersCollection = require('collections/customers');

    var temp = require("text!templates/content/customers.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'customer-page',
        titleKey: 'customers',

        setCollection: function () {
            this.collection = new CustomersCollection();
        },

        onRender: function() {
            this.ListContainer.show(new CustomersView({
                collection: this.collection
            }));
        }

    });
});
